import React from 'react'
import IconSVG from 'svg-inline-react'
import StatusAvatar from 'components/shared/AgentStatusAvatar'
import ACCESS from 'utils/Access'
import cx from 'classnames'
import './style'
import { allScopes } from '../TeamConstants'
import OrgConstants from 'constants/OrgConstants'
import { Button, Input } from '@driftt/tide-core-legacy'

import calendarIconSrc from '!svg-inline?removeTags=true!images/meetings/calendar-duration-30m.svg'

const ScopeLabel = ({ name }) =>
  <span className="user-scope-text">{name}</span>
const renderScopeLabel = user => getScopeLabels(user)
  .map(ScopeLabel)

const hasScope = (scope, { scopes }) => scopes.includes(scope)
const getScopeLabels = user => {
  const { ADMIN, NON_ADMIN, CALENDAR_USER, VIDEO_USER } = allScopes
  let labels = []
  if (hasScope(ADMIN, user)) {
    labels.push({ name: 'Admin', key: ADMIN })
  }

  if (hasScope(CALENDAR_USER, user)) {
    labels.push({ name: 'Calendar user', key: CALENDAR_USER })
  }
  // Video only
  if (hasScope(VIDEO_USER, user)) {
    labels.push({ name: 'Video user', key: VIDEO_USER })
  }

  if (hasScope(NON_ADMIN, user)) {
    labels.push({ name: 'Chat user', key: 'chat' })
  }

  return labels
}

const ResendInvitation = ({ user, resendInvitationState, resendInvite }) => {
  const currentResendInvitationState = resendInvitationState[user.email]

  const getButtonCopy = () => {
    switch (currentResendInvitationState) {
      case OrgConstants.RESEND_INVITE_STARTING:
        return 'Resending'
      case OrgConstants.RESEND_INVITE_DONE:
        return 'Sent!'
      default:
        return 'Resend Invite'
    }
  }

  const inviteButtonDisabled = () => {
    return currentResendInvitationState === OrgConstants.RESEND_INVITE_DONE ||
      currentResendInvitationState === OrgConstants.RESEND_INVITE_STARTING
  }

  const onClick = (e) => {
    e.stopPropagation()
    resendInvite(user.email, user.orgId)
  }

  return (
    <Button
      onClick={onClick}
      type="tertiary"
      size="small"
      disabled={inviteButtonDisabled()}
      className="resend-invite"
    >
      {getButtonCopy()}
    </Button>
  )
}

function enableHovering () {
  if (ACCESS.hasPaidGates()) return 'user-hover'
  return 'non-paying'
}

const TeamTableBody = ({
  users,
  connectedUsers,
  onTeamMemberSelect,
  onTeamMemberClick,
  showPermissionsColumn = true,
  selectedUsers,
  resendInvite,
  resendInvitationState
}) => (
  <tbody className="drift-form">
    {users.map(user => (
      <tr
        className={enableHovering}
        key={`${user.id}-${user.email}`}
      >
        {onTeamMemberSelect && (
          <td>
            <Input
            type="checkbox"
             onChange={onTeamMemberSelect(user.id)}
             checked={!!_.find(selectedUsers, { id: user.id })}
             />
          </td>
        )}
        <td
          className="team-user"
          onClick={() => onTeamMemberClick && onTeamMemberClick(user)}
        >
          <StatusAvatar user={user} />
          <div className="team-user-info">
            <strong className={cx({ 'email-only': !user.name })} > {user.name || user.email}
              {connectedUsers && connectedUsers.has(user.id) && <IconSVG className="user-list-calendar-icon" src={calendarIconSrc}/>}
            </strong>
            {user.name && user.email && (
              <small>{user.email}</small>
            )}
          </div>
          {user.status === 'INVITED' && (
            <ResendInvitation user={user} resendInvite={resendInvite} resendInvitationState={resendInvitationState} />
          )}
        </td>
        {showPermissionsColumn && (
          <td
            className="team-permissions"
            onClick={() => onTeamMemberClick && onTeamMemberClick(user)}
          >
            <div className="drift-gated-content">
              <div>
                {renderScopeLabel(user)}
                {user.role === 'OWNER' && <ScopeLabel key="Account Owner" name="Account Owner"/>}
              </div>
            </div>
          </td>
        )}
        {showPermissionsColumn && (
          <td
            className="team-edit-button"
            onClick={() => onTeamMemberClick && onTeamMemberClick(user)}
          >
            <Button
              type="tertiary"
              size="small"
              onClick={() => onTeamMemberClick && onTeamMemberClick(user)}
            >
            Edit</Button>
          </td>
        )}
      </tr>
    ))}
  </tbody>
)

export default TeamTableBody



// WEBPACK FOOTER //
// ./src/scripts/components/settings/team/TeamTable/TeamTableBody.js